var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.537,
    height: 29.829,
    viewBox: "0 0 30.537 29.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "government-icon",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65107",
    "data-name": "Path 65107",
    d: "M3.79,25.418V24.093h.77V23.46h.808v-7.8H3.718V13.84h23.1v1.822h-1.65v7.8h.808v.634h.77v1.325ZM16,.54c2.676-1.849,2.875,1.812,5.5-.475V3.8c-2.507,2.254-3.047-1.387-5.5.462V.54ZM15.619.2V4.553l12.03,6.153v1.941H2.96V10.709l11.993-6.17V.2ZM28.28,28h-.122V26.163H2.378V28H2.256v0H0v1.824H30.537V28H28.28v0Zm-19.066-3.9h.932V23.46h.808v-7.8H8.407v7.8h.808v.634Zm5.589,0h.934V23.46h.805v-7.8H14v7.8H14.8v.634Zm5.586,0h.934V23.46h.808v-7.8h-2.55v7.8h.808v.634Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.4cb4284ec277f734b1c70f76b9279522.svg";
export { ForwardRef as ReactComponent };